import { hasProperty, localSet, localGet } from "../../utils/index";
const user = {
  state: {
    userInfo: {
      token: localGet("token"),
      userId: localGet("userid"),
      userid: localGet("userid"),
      userName: localGet("userName"),
      menuList: localGet("menuList"),
      email: localGet("email")
    }
  },
  mutations: {
    SET_USER: (state: any, val: any) => {
      if (hasProperty(val, "token")) {
        state.userInfo.token = val.token;
        localSet("token", val.token);
      }
      if (hasProperty(val, "userid")) {
        state.userInfo.userid = val.userid;
        localSet("userid", val.userid);
      }
      if (hasProperty(val, "name")) {
        state.userInfo.userName = val.name;
        localSet("userName", val.name);
      }
      if (hasProperty(val, "menuList")) {
        state.userInfo.menuList = val.menuList;
        localSet("menuList", JSON.stringify(val.menuList));
      }
      if (hasProperty(val, "email")) {
        state.userInfo.email = val.email;
        localSet("email", val.email);
      }
    }
  },
  actions: {
    storeUser({ commit }: any, data: any) {
      commit("SET_USER", data);
    }
  }
};
//const menus:any[] = [{index: 1, name: "ok", api: ["www.test.com"]}];
export default user;
